import React from "react";
import { ActivityIndicator } from "react-native";
import Dialog from "../dialog/Dialog";

/**
 * Dialog that shows a progress indicator until the isVisible prop is false.
 */
const ProgressDialog = props => (
  <Dialog {...props} autoSnap={false}>
    <ActivityIndicator animating size="large" color={props.color || "white"}/>
  </Dialog>
);

export default ProgressDialog;
